import { Component, Input } from "@angular/core";
import { ViewDetailsComponent } from "../../../view-details/view-details.component";
import { ActivityLogTimelineComponent } from "../../../activity-log-timeline/activity-log-timeline.component";
import { NoDataComponent } from "../../../no-data/no-data.component";
import { InventoryService } from "../../../../services/inventory-service";
import { LoadingService } from "../../../../services/loading.service";
import { CONTAINER_VIEW_PAGE_CONFIG } from "../config/container-view.config";
import { CommonUtils } from "../../../../utils/common-utils";
import { OperationAPIService } from "../../../../services/operations.service";
import { ToasterService } from "../../../../services/toaster.service";

@Component({
  selector: "app-container-activity-log",
  standalone: true,
  imports: [
    ViewDetailsComponent,
    ActivityLogTimelineComponent,
    NoDataComponent
  ],
  templateUrl: "./container-activity-log.component.html",
  styleUrl: "./container-activity-log.component.scss"
})
export class ContainerActivityLogComponent {
  containerMeta = CONTAINER_VIEW_PAGE_CONFIG.tableMeta;
  containerData!: any;

  @Input() containerId: string = "";

  constructor(private inventoryService: InventoryService,
              private loadingService: LoadingService,
              private operationsService: OperationAPIService,
              private toasterService: ToasterService) {

  }

  ngOnInit(): void {
    this.getContainerActivityLog();
  }

  getContainerActivityLog() {
    if (!this.containerId) {
      console.error("Container ID is not provided.");
      return;
    }
    this.loadingService.show();
    this.inventoryService.getContainerActivity(this.containerId).subscribe({
      next: (res: any) => {
        this.containerData = res.data;
        this.postProcessData(this.containerData);
        this.loadingService.hide();
      },
      error: (err) => {
        console.error("Error fetching container data:", err);
        this.loadingService.hide();
      }
    });
  }

  private postProcessData(container: any) {
    const itemList = container.documentDetails;
    if (!itemList) return;

    // Extract unique blNos from documentDetails
    const blNoList = itemList
      .map((doc: any) => doc?.blNo)
      .filter((blNo: string) => blNo && blNo.trim());

    // Set unique blNos to container
    container.blNos = [...new Set(blNoList)];
  }

  handleRowAction(event: { actionName: string; record: any }) {
    console.log("Row action triggered:", event);
    this.downloadWeighmentSlip(event.record.weighingRecordId);
  }

  private downloadWeighmentSlip(id: any) {
    this.loadingService.show();
    this.operationsService.downloadWeighmentSlip(id).subscribe({
      next: (res: any) => {
        const filename = `weighment-slip-${id}.pdf`;
        CommonUtils.savePdf(res.data, filename);
        this.loadingService.hide();
        this.toasterService.success("Weighment slip downloaded successfully");
      },
      error: (err) => {
        this.loadingService.hide();
        this.toasterService.error(err.error.errorDesc);
      }
    });

  }
}
